import {ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
// import gql from 'graphql-tag';
// import { APIService } from '../../API.service';
import {AccessGroupService} from './../access-group.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
// import { Apollo } from 'apollo-angular';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import { DatepickerOptions } from 'ng2-datepicker';
import locale from 'date-fns/locale/en-US';
import { getYear, max, set } from 'date-fns';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { forkJoin } from 'rxjs';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import swal from 'sweetalert2/dist/sweetalert2.js';
import { Store } from '@ngrx/store';
import { environment } from './../../../environments/environment';
// import 'sweetalert2/src/sweetalert2.scss';
// import { ClassicEditor, Bold, Essentials, Italic, Mention, Paragraph, Undo } from 'ckeditor5';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

declare var jQuery: any;
import {
	ClassicEditor,
	AccessibilityHelp,
	Alignment,
	Autoformat,
	AutoImage,
	AutoLink,
	Autosave,
	BlockQuote,
	Bold,
	CloudServices,
	CodeBlock,
	Essentials,
	FindAndReplace,
	GeneralHtmlSupport,
	Heading,
	HorizontalLine,
	ImageBlock,
	ImageInsertViaUrl,
	ImageToolbar,
	ImageUpload,
	Indent,
	IndentBlock,
	Italic,
	Link,
	Paragraph,
	PasteFromOffice,
	SelectAll,
	SourceEditing,
	Style,
	TextTransformation,
	Undo,
	type EditorConfig
} from 'ckeditor5';
import { LambdaFunctionService } from '../../service/lambda-function.service';
import { HttpClient } from '@angular/common/http';


@Component({
  selector: 'app-admin-single-learner-map',
  templateUrl: './admin-single-learner-map.component.html',
  styleUrls: ['./admin-single-learner-map.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdminSingleLearnerMapComponent implements OnInit {
    editor;
    editor2;
    public isLayoutReady = false;
    public config: EditorConfig = {}; // CKEditor needs the DOM tree before calculating the configuration.
    toolbar = [
      // default value
      ["bold", "italic"],
      ["underline", "strike"],
      ["code", "blockquote"],
      ["ordered_list", "bullet_list"],
      [{ heading: ["h1", "h2", "h3", "h4", "h5", "h6"] }],
      ["link", "image"],
      ["text_color", "background_color"],
      ["align_left", "align_center", "align_right", "align_justify"],
    ]
    currentLM_id: string;
    private currentLM: any = [];
    public allcolumns: any = [];
    private columns: any = [];
    private allmaptypes: any = [];
    private allOwners: any = [];
    public column_name: any = '';
    private column_order: number;
    private newCardId: string;
    private card_name: any = '';
    private card_text: string = '';
    private card_column: string = '';
    private card_order: number;
    private GET_LEARNERMAP: string;
    private open_card: any;
    private old_card: any;
    public cardModal: boolean = false;
    public cloneModal: boolean;
    private cloneCard_name: any;
    private learner_maps: any = [];
    private cloneCard_lm: string;
    private cloneCard_column: string;
    private editcard: any = [];
    private CardId: string;
    private OpenCol: string = '';
    learner_map: string = '';
    public editMap: boolean = false;
    private cloneCol: any = '';
    private url: any;
    private cloneColumn: string = '';
    private editColId: string = '';
    private editColName: any = '';
    private col_nmbr: number;
    private card_nmbr: number;
    private dropPos: number;
    private dragPos: number;
    private dragList: any;
    private trackIds: any = [];
    public isLoading:boolean = false;
    private edit_map: any;
    private edit_maptype: any;
    private edit_mapLocation: any = '';
    private edit_mapImage: any = '';
    private prework_days: any;
    private assessment_deadline: any;
    private before_day_point: any;
    private days_test_opens: any;
    private days_test_close: any;
    private first_training: any;
    private last_training: any;
    private open_date: any;
    private close_date: any;
    private map_owner: any;
    toaster_time = 1000;
    order_counter:any = 0;
    hashTitleStaging = '';
    hashTitleProduction = '';
    ngrxAccessGroup:any;
    wistia_src:any;
    loading:boolean =false;

    mapOwnersStaticObj = [
      { checked: false, email: 'testowner@foursightonline.com', member_id: 200002 },
      { checked: false, email: 'sarah@blairmiller.com', member_id: 9760 },
      { checked: false, email: 'kelly@foursightonline.com', member_id: 30781 },
      { checked: false, email: 'greg@foursightonline.com', member_id: 99764 },
      { checked: false, email: 'christine@foursightonline.com', member_id: 196839 },
      { checked: false, email: 'sarah@foursightonline.com', member_id: 23927 }
    ] 

    options: DatepickerOptions = {
      minYear: getYear(new Date()) - 50, // minimum available and selectable year
      maxYear: getYear(new Date()) + 50, // maximum available and selectable year
      placeholder: '', // placeholder in case date model is null | undefined, example: 'Please pick a date'
      format: "MM/dd/yyyy", // date format to display in input
      formatTitle: 'LLLL YYYYY',
      formatDays: 'EEEEE',
      firstCalendarDay: 0, // 0 - Sunday, 1 - Monday
      locale: locale, // date-fns locale
      position: 'bottom',
      inputClass: '', // custom input CSS class to be applied
      calendarClass: 'datepicker-default', // custom datepicker calendar CSS class to be applied
      scrollBarColor: '#dfe3e9', // in case you customize you theme, here you define scroll bar color
    };

    // options: DatepickerOptions = {
    //     minYear: 1970,
    //     maxYear: 2030,
    //     format: 'DD-MM-YYYY',
    //     formatTitle: 'DD-MM-YYYY',
    //     firstCalendarDay: 0, // 0 - Sunday, 1 - Monday
    //     placeholder: 'Click to select a date', // HTML input placeholder attribute (default: '')
    //     inputClass: 'form-control',
    // };

  constructor(private changeDetector: ChangeDetectorRef,private accessgroup: AccessGroupService, private sanitizer: DomSanitizer, private activatedRoute: ActivatedRoute, private modalService: NgbModal, private router: Router,private lmda_service: LambdaFunctionService , public store:Store<any>, public http:HttpClient) { }

  ngOnDestroy() {
    // for udpating order
    this.getLM();
  }

  async ngOnInit() {
    var that = this;
    this.editor = ClassicEditor;
    this.editor2 = ClassicEditor;
    this.ngrxAccessGroup =this.store.select<any>((state) => state.profile.accessGroupData);
  	this.ngrxAccessGroup.subscribe(message => { 
        // Allow access if Redux store has data, don't require specific learner_maps_admin flag
        // as it may not always be populated

    },
    err => {
        // Log errors if any
        console.log(err);
    })

    localStorage.setItem('adminDateVisible', 'true');
    this.newCardId = '';
    this.activatedRoute.params.subscribe((params: Params) => {
      this.currentLM_id = params['id'];
      this.getLM();
    });
    var that = this;
    jQuery(document).click(function (event) {
      console.log(event.target)
      if (event.target.id != 'open-column') {
        that.OpenCol = '';
      }
    });

    $(document).on("focus","#editor-subtitle",function() {
      $('.editor-script--spc').addClass("editor-script--visible");
    });
    // $(document).on("mouseleave",".editor-script--visible",function() {
    //   $(this).removeClass("editor-script--visible");
    // });

  }

  public ngAfterViewInit(): void {
		this.config = {
			toolbar: {
				items: [
					'undo',
					'redo',
					'|',
					'sourceEditing',
					'findAndReplace',
					'selectAll',
					'|',
					'heading',
					'style',
					'|',
					'bold',
					'italic',
					'|',
					'horizontalLine',
					'link',
					'blockQuote',
					'codeBlock',
					'|',
					'alignment',
					'|',
					'outdent',
					'indent',
					'|',
					'accessibilityHelp'
				],
				shouldNotGroupWhenFull: false
			},
			plugins: [
				AccessibilityHelp,
				Alignment,
				Autoformat,
				AutoImage,
				AutoLink,
				Autosave,
				BlockQuote,
				Bold,
				CloudServices,
				CodeBlock,
				Essentials,
				FindAndReplace,
				GeneralHtmlSupport,
				Heading,
				HorizontalLine,
				ImageBlock,
				ImageInsertViaUrl,
				ImageToolbar,
				ImageUpload,
				Indent,
				IndentBlock,
				Italic,
				Link,
				Paragraph,
				PasteFromOffice,
				SelectAll,
				SourceEditing,
				Style,
				TextTransformation,
				Undo
			],
			heading: {
				options: [
					{
						model: 'paragraph',
						title: 'Paragraph',
						class: 'ck-heading_paragraph'
					},
					{
						model: 'heading1',
						view: 'h1',
						title: 'Heading 1',
						class: 'ck-heading_heading1'
					},
					{
						model: 'heading2',
						view: 'h2',
						title: 'Heading 2',
						class: 'ck-heading_heading2'
					},
					{
						model: 'heading3',
						view: 'h3',
						title: 'Heading 3',
						class: 'ck-heading_heading3'
					},
					{
						model: 'heading4',
						view: 'h4',
						title: 'Heading 4',
						class: 'ck-heading_heading4'
					},
					{
						model: 'heading5',
						view: 'h5',
						title: 'Heading 5',
						class: 'ck-heading_heading5'
					},
					{
						model: 'heading6',
						view: 'h6',
						title: 'Heading 6',
						class: 'ck-heading_heading6'
					}
				]
			},
			htmlSupport: {
				allow: [
					{
						name: /^.*$/,
						styles: true,
						attributes: true,
						classes: true
					}
				]
			},
			image: {
				toolbar: ['imageTextAlternative']
			},
			initialData:'',
			link: {
				addTargetToExternalLinks: true,
				defaultProtocol: 'https://',
				decorators: {
					toggleDownloadable: {
						mode: 'manual',
						label: 'Downloadable',
						attributes: {
							download: 'file'
						}
					}
				}
			},
			placeholder: 'Type or paste your content here!',
			style: {
				definitions: [
					{
						name: 'Article category',
						element: 'h3',
						classes: ['category']
					},
					{
						name: 'Title',
						element: 'h2',
						classes: ['document-title']
					},
					{
						name: 'Subtitle',
						element: 'h3',
						classes: ['document-subtitle']
					},
					{
						name: 'Info box',
						element: 'p',
						classes: ['info-box']
					},
					{
						name: 'Side quote',
						element: 'blockquote',
						classes: ['side-quote']
					},
					{
						name: 'Marker',
						element: 'span',
						classes: ['marker']
					},
					{
						name: 'Spoiler',
						element: 'span',
						classes: ['spoiler']
					},
					{
						name: 'Code (dark)',
						element: 'pre',
						classes: ['fancy-code', 'fancy-code-dark']
					},
					{
						name: 'Code (bright)',
						element: 'pre',
						classes: ['fancy-code', 'fancy-code-bright']
					}
				]
			}
		};

		this.isLayoutReady = true;
		this.changeDetector.detectChanges();
	}
  public hideScript() {
    $('.editor-script--spc').removeClass("editor-script--visible");
  }

  public async NewColumn() {
    let that = this;
    console.log(this.currentLM)
    // console.log(this.api.GetLearnerMap(this.currentLM_id))
    let data = {
      title: this.column_name,
      position: 1,
      learner_map_column_type_id: 2
    }
    this.http.post(`${environment.profileURL}/api/v1/learner_maps/${this.currentLM.id}/learner_map_columns`,data).subscribe(async (res:any)=> {
       that.column_name = '';
      setTimeout(function() {
          this.toastr.options = {
              closeButton: true,
              progressBar: true,
              timeOut: that.toaster_time
          };
          this.toastr.success('New column has been created!', 'Nice!');
      }, 1000);
      that.getLM();
    })
  }

  private async NewCard(col) {
    console.log("column data", col)
    let that = this;
    let data = {
      title: this.card_name,
      position: col?.cards?.length + 1
    }
    this.http.post(`${environment.profileURL}/api/v1/learner_maps/${col.learner_map_id}/learner_map_columns/${col.id}/learner_map_cards`,data).subscribe(async (res:any)=> {
      setTimeout(function() {
            this.toastr.options = {
                closeButton: true,
                progressBar: true,
                timeOut: that.toaster_time
            };
            this.toastr.success('New card has been created!', 'Nice!');
        }, 1000);
        that.cancelAddCard()
        that.getLM();
    })
  }

  private async getLM() {
    console.log('calling learner map...!')
    var that = this;
    let email:any = localStorage.getItem('email')?.toLowerCase();
    this.http.get(`${environment.profileURL}/api/v1/learner_maps/${this.currentLM_id}`).subscribe(async (res:any)=> {
      console.log("res=>", res);
      (res.learner_map.owner_users || []).forEach(addedItem => {
        this.mapOwnersStaticObj.forEach(owner => {
          if (owner.member_id === addedItem.id) {
            owner.checked = true;
          }
        });
      });
      that.isLoading = true;
      that.learner_map = '';
      let hash:number = 0;
      let map = res?.learner_map?.learner_map_columns || [];
      let mapTitle = res?.learner_map?.title || '';
      this.allcolumns = map.sort((a, b) => a.position - b.position);
      map.forEach((col, index) => {
          that.trackIds[index] = "list-" + col.id;
      })
      // remove feature between #
      for(let  i = 0; i < mapTitle?.length; i++) {
        if(mapTitle[i] === '#') {
          hash += 1;
        }
        if(hash < 1) {
          that.learner_map += mapTitle[i];
        }
      }
      that.currentLM = res?.learner_map;
    })
    this.http.get(`${environment.profileURL}/api/v1/learner_map_types`).subscribe(async (res:any)=> {
      console.log("res=>", res?.learner_map_types);
      this.allmaptypes = res?.learner_map_types;
    })
  }

  private addCardlist(id) {
    this.newCardId = id;
  }

  private cancelAddCard() {
    this.card_name = '';
    this.newCardId = '';
  }

  private onTaskDrop(event: CdkDragDrop<any[]>) {
    var that = this;
    this.CardId = event.item.element.nativeElement.id;

    if (event.previousContainer.id === event.container.id) {
      // Reorder within the same column
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);

      const currentColId = event.container.id.replace('list-', '');
      const col = that.allcolumns.find((c: any) => String(c.id) === String(currentColId));
      if (!col) return;

      // Patch ALL cards with their new positions — only patching the moved card
      // leaves siblings with stale server-side positions, causing the order to
      // revert when getLM() re-fetches and the server sorts by position.
      const patches = col.learner_map_cards.map((card: any, index: number) =>
        this.http.patch(
          `${environment.profileURL}/api/v1/learner_maps/${col.learner_map_id}/learner_map_columns/${col.id}/learner_map_cards/${card.id}`,
          { title: card.title, position: index + 1 }
        )
      );

      forkJoin(patches).subscribe(() => {
        that.getLM();
        setTimeout(function() {
          this.toastr?.options && (this.toastr.options = { closeButton: true, progressBar: true, timeOut: that.toaster_time });
          this.toastr?.success('Card order has been updated!', 'Nice!');
        }, 1000);
      }, (err: any) => {
        if (err) {
          setTimeout(function() {
            this.toastr?.error(err?.error?.errors, 'Oops!');
          }, 1000);
        }
      });

    } else {
      // Move card to a different column — capture card data before transferring
      const precColId = event.previousContainer.id.replace('list-', '');
      const currentColId = event.container.id.replace('list-', '');
      const movedCardId = event.item.element.nativeElement.id;
      const prevCol = that.allcolumns.find((col: any) => String(col.id) === String(precColId));
      const movedCard = prevCol?.learner_map_cards?.find(
        (card: any) => String(card.id) === String(movedCardId)
      );

      // Apply the visual transfer immediately so the card doesn't snap back
      // while the API call is in flight.
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );

      const data = {
        target_learner_map_column_id: parseInt(currentColId),
        title: movedCard?.title ?? '',
        position: event.currentIndex + 1
      };

      this.http.patch(
        `${environment.profileURL}/api/v1/learner_maps/${this.currentLM.id}/learner_map_columns/${precColId}/learner_map_cards/${movedCardId}`,
        data
      ).subscribe(() => {
        that.getLM();
        setTimeout(function() {
          this.toastr?.options && (this.toastr.options = { closeButton: true, progressBar: true, timeOut: that.toaster_time });
          this.toastr?.success('Card order has been updated!', 'Nice!');
        }, 1000);
      }, (err: any) => {
        if (err) {
          // Revert the visual transfer on failure
          transferArrayItem(
            event.container.data,
            event.previousContainer.data,
            event.currentIndex,
            event.previousIndex
          );
          setTimeout(function() {
            this.toastr?.error(err?.error?.errors, 'Oops!');
          }, 1000);
        }
      });
    }
  }

  public async onColumnDrop(event) {
    console.log(event);
    var that = this;
    moveItemInArray(this.allcolumns, event.previousIndex, event.currentIndex);
    console.log(this.allcolumns)
    let completed = 0;
    const total = this.allcolumns.length;
    this.allcolumns.forEach((col, index) => {
      let data = {
        title: col.title,
        position: index + 1
      };
      this.http.patch(`${environment.profileURL}/api/v1/learner_maps/${col.learner_map_id}/learner_map_columns/${col.id}`, data).subscribe((res: any) => {
        console.log(res);
        completed++;
        if (completed === total) {
          that.getLM();
          setTimeout(function() {
            this.toastr.options = {
                closeButton: true,
                progressBar: true,
                timeOut: that.toaster_time
            };
            this.toastr.success('Column order has been updated!', 'Nice!');
            this.isLoading = true;
          }, 1000);
        }
      });
    });
  }

  public close(popupName) {
    // $('.card-modal').css('display', 'none');
    if(popupName == 'editmap') {
      this.editMap = false;
    }else if(popupName == 'clone') {
      this.cloneModal = false;
    } else {
      this.cardModal = false;
    }
}

  private async openCard( card, column, col_index, card_index) {
    this.editcard = [];
    this.card_nmbr = card_index + 1;
    this.col_nmbr = col_index + 1;

    // this.cardModal = this.modalService.open(content, { windowClass: 'modal-module in' });
    // $('.card-modal').css('display','block');
    this.cardModal = true;
    this.old_card = card;
    this.open_card = card;
    if(this.open_card?.type == 'Var_Wistia') {
      this.wistia_src = "//fast.wistia.net/embed/iframe/" + this.open_card?.link  +"?videoFoam=true"
      this.wistia_src = this.sanitizer.bypassSecurityTrustResourceUrl(this.wistia_src)
      console.log(this.wistia_src)
    }
    this.cloneCard_column = column.id;
    this.columns = this.allcolumns;
    var that = this;
    // await this.api.ListLearnerMaps().then(function (data) {
    //   that.learner_maps = data.items;
    // });
    // await client.models?.["LearnerMap"]?.list({limit: 1000}).then(async (data:any) => {
    //   that.learner_maps = await data.data;
    //   console.log("=======>>>",data);
    //   console.log("=======>>>",data?.data);
    //   console.log("=======>>>",that.learner_maps);
    // })
    console.log(this.open_card);
    this.http.get(`${environment.profileURL}/api/v1/learner_maps?per_page=1000`).subscribe((res:any) => {
        if(res){
          console.log(res?.learner_maps);
          that.learner_maps=res?.learner_maps
        }
    }, error => {
      console.log(error);
    });
    console.log(this.open_card);
    if(this.open_card.id == '65ddf595-c1f3-46ed-9167-2fe14770657d'){
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.open_card.link);
    }else{
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + this.open_card.link + '?modestbranding=1&amp;rel=0&amp;showinfo=0');
    }
  }

  private cloneCard() {
    // this.cloneModal = this.modalService.open(content, { size: 'sm', windowClass: 'in' });
    this.cloneModal = true;
    this.cloneCard_name = this.open_card.title;
    this.cloneCard_lm = this.currentLM_id;
  }

  private async getColumns() {
    this.cloneCard_column = '';
    var that = this
    console.warn("get columns", this.cloneCard_lm)
    console.warn("get lm", this.cloneCard_column)
    this.learner_maps.forEach(async (map, index) => {
      if(map.id == this.cloneCard_lm){
        this.http.get(`${environment.profileURL}/api/v1/learner_maps/${map.id}/learner_map_columns?per_page=100`).subscribe((res:any) => {
          that.columns = res?.learner_map_columns;
          // that.columns = allCols.data;
        })
      }
    })
  }

  private async createCard() {
    var that = this;
    let data = {
      target_learner_map_id : this.cloneCard_lm,
      target_learner_map_column_id: this.cloneCard_column,
      // target_learner_map_card_name: this.cloneCard_name
    }
    this.http.post(`${environment.profileURL}/api/v1/learner_maps/${this.currentLM_id}/learner_map_columns/${this.open_card?.learner_map_column_id}/learner_map_cards/${this.open_card?.id}/clone_to_another_learner_map?per_page=100`,data).subscribe((res:any) => {
      that.cloneCard_name = '';
        that.cloneCard_lm = '';
        that.cloneCard_column = '';
        that.cloneModal = false;
        setTimeout(function() {
          this.toastr.options = {
            closeButton: true,
            progressBar: true,
            timeOut: 2000
          };
          this.toastr.success('New card has been created!', 'Nice!');
        }, 1000);
        that.getLM();
    })

  }

  private editCard(card) {
    this.editcard = card;
    const openVal = card.opened_at || card.open;
    const closeVal = card.closed_at || card.close;
    this.open_date = openVal ? new Date(openVal) : null;
    this.close_date = closeVal ? new Date(closeVal) : null;
    this.getLM();
  }

  private async updateCard() {
    console.log("update card",this.editcard)
    if(this.editcard.body == ""){
      this.editcard.body = null;
    }
    if(this.editcard.bg == ""){
      this.editcard.bg = null;
    }
    if(this.editcard.link == ""){
      this.editcard.link = null;
    }
    if(this.editcard.text == ""){
      this.editcard.text = null;
    }
    if(this.editcard.type == ""){
      this.editcard.type = null;
      this.editcard.bg = null;
      this.editcard.text = null;
      this.editcard.link = null;
    }
    if(this.editcard.target == "") {
      this.editcard.target = null;
    }
    var that = this;
    let data: any = {
      title: that.editcard.title,
      position: that.editcard.position,
      active: that.editcard.active,
      kind: that.editcard.kind,
      lesson: that.editcard.lesson,
      medium: that.editcard.medium,
      runtime: that.editcard.runtime,
      link: that.editcard.link,
      background: that.editcard.background,
      button: that.editcard.button,
      text: that.editcard.text,
      target: that.editcard.target,
      body: that.editcard.body,
      label: that.editcard.label,
      opened_at: this.open_date ? new Date(this.open_date).toISOString() : null,
      closed_at: this.close_date ? new Date(this.close_date).toISOString() : null,
    }
    this.http.patch(`${environment.profileURL}/api/v1/learner_maps/${this.currentLM_id}/learner_map_columns/${this.editcard?.learner_map_column_id}/learner_map_cards/${that.editcard.id}`,data).subscribe(async (result:any)=> {
      // Exit edit mode without overwriting open_card from stale data
      that.editcard = [];
      // Reload the learner map to get fresh data
      await that.getLM();
      // Set open_card from the API response (has the updated dates)
      that.open_card = result?.learner_map_card;
      // Show success after modal is closed
      Swal.fire({
        icon: 'success',
        title: 'Nice!',
        text: 'Card has been updated!',
        timer: 2000,
        showConfirmButton: false,
        customClass: { container: 'swal-above-modal' }
      });
    })
  }

  private cancelCard() {
    console.log("cancel card", this.allcolumns, this.col_nmbr, this.card_nmbr)
  	this.open_card = this.allcolumns[this.col_nmbr-1]['learner_map_cards'][this.card_nmbr - 1];
    this.editcard = [];
  }

  private openColumn(col) {
    this.cloneColumn = '';
    if (this.OpenCol == '') {
      this.OpenCol = col.id
    } else if (this.OpenCol == col.id) {
      this.OpenCol = '';
    }
    else {
      this.OpenCol = col.id;
    }
  }

  private closeCol() {
    this.OpenCol = '';
  }

  	private async deleteCard() {
	    var that = this;
      console.log("open_card",this.open_card, this.currentLM_id)
	    Swal.fire({
	        title: "Are you sure?",
	        text: "Are you sure, you want to delete this Card? This cannot be undone!",
	        icon: "warning",
	        showCancelButton: true,
	        focusCancel: true,
	        confirmButtonColor: "#dc3545",
	        cancelButtonColor: '#28a745',
	        confirmButtonText: "Yes, delete it!"
		}).then((result) => {
	        if (result['value'] == true) {

            this.http.delete(`${environment.profileURL}/api/v1/learner_maps/${this.currentLM_id}/learner_map_columns/${this.open_card.learner_map_column_id}/learner_map_cards/${this.open_card.id}`).subscribe(async (res:any)=> {
              console.log("res=>", res);
               setTimeout(function() {
                this.toastr.options = {
                    closeButton: true,
                    progressBar: true,
                    timeOut: that.toaster_time
                };
                this.toastr.success('Your card has been deleted!', 'Nice!');
	            }, 1000);
              that.cardModal = false;
		          that.getLM();
            }, err => {
              setTimeout(function() {
                      this.toastr.options = {
                          closeButton: true,
                          progressBar: true,
                          timeOut: that.toaster_time
                      };
                      this.toastr.error(err?.error?.errors, 'Oops!');
                  }, 1000);
                  this.isLoading = true;
                  that.cardModal = false;
            })
	        }
		},function(dismiss){
			jQuery('.swal2-container').addClass('hide');
			jQuery('body').removeClass('swal2-shown');
			jQuery('html').removeClass('swal2-shown');
		});
    jQuery('.swal2-container').css('z-index','99999') 
	}

  private columnModal(col) {
  	this.cloneCol = '';
    this.cloneColumn = col.id;
  }
  private closeColumn() {
    this.cloneColumn = '';
  }


  // public async checkedAllCardCloned(colId:any,col:any) {
  //   var that = this;
  //   let attempts = 0;
  //   const maxAttempts = 5;
  //   while (attempts < maxAttempts) {
  //     attempts++;
  //     // Get current column card count
  //     const newCol:any = await client.models.Column.get({ id: colId });
  //     const newColDetails:any = newCol?.data;
  //     const newColCards:any = await newColDetails?.cards({ limit: 1000 }) || [];
  //     const newColCardsDetails:any = newColCards.data;
  //     const newColCardsDetailsLength:any = newColCardsDetails.length;
  //     const orginalCardsLength:any = col.cards.length;
  //     console.log('newColCardsDetailsLength',newColCardsDetails)
  //     setTimeout(async() => {
  

  //       if(newColCardsDetailsLength === orginalCardsLength){
  //         console.log("No Cards to Clone")
  //         return;
  //       }

  //       const existingCards = newColCardsDetails.map((c: any) => c.title);
  //       const missingCards = col.cards.filter((card: any) => !existingCards.includes(card.title));
  //       console.warn("missingCards",missingCards, existingCards)
  
  //       for (const card of missingCards) {
  //           try {
  //               await client.models.Card.create({
  //                   title: card.title,
  //                   active: card.active,
  //                   type: card.type,
  //                   lesson: card.lesson,
  //                   medium: card.medium,
  //                   runtime: card.runtime,
  //                   parent: card.parent,
  //                   link: card.link,
  //                   bg: card.bg,
  //                   body: card.body,
  //                   button: card.button,
  //                   text: card.text,
  //                   target: card.target,
  //                   open: card.open,
  //                   close: card.close,
  //                   order: card.order,
  //                   cardColumnId: colId
  //               });
  //               console.log("Cloned missing card:", card.title);
  //             } catch (err) {
  //                 console.error("Error cloning card:", card.title, err);
  //             }
  //         }
  //     }, 500);

  //   }
  // }

  private async copyColumn(col) {
    var that = this;
    this.isLoading = false;
    let newColId;
    console.log(col)
    // create column and create cards

    this.http.post(`${environment.profileURL}/api/v1/learner_maps/${col.learner_map_id}/learner_map_columns`,{
      title: that.cloneCol,
      position: col.position,
      learner_map_column_type_id: col.learner_map_column_type_id ? col.learner_map_column_type_id : 2,
    }).subscribe(async (res:any)=> {
      await this.cloneCards(res.learner_map_column.id,col).then(()=> {
        setTimeout(async function() {
          await that.getLM();
            this.toastr.options = {
                closeButton: true,
                progressBar: true,
                timeOut: that.toaster_time
            };
            this.toastr.success('Your column has been created!', 'Nice!');
            that.isLoading = true;
        }, 1000);
        that.cloneColumn = '';
      })
    })
    
    // const ColumnCardPromise = new Promise((resolve, reject) => {
    //   setTimeout(async () => {
    //     resolve(
  }


  private async cloneCards(colId: any, col: any) {
  try {

    for (const card of col.learner_map_cards) {
      console.log("colID", card);
      card.active = true;

      const cardPayload: any = {
        title: card.title,
        active: card.active,
        kind: card.kind,
        lesson: card.lesson,
        medium: card.medium,
        runtime: card.runtime,
        parent: card.parent,
        link: card.link,
        bg: card.bg,
        body: card.body,
        button: card.button,
        text: card.text,
        target: card.target,
        open: card.open,
        close: card.close,
        position: card.position,
      };

      // Remove keys with undefined, null, or empty string values
      // Object.keys(cardPayload).forEach(
      //   key =>
      //     (cardPayload[key] == null || cardPayload[key] === '') &&
      //     delete cardPayload[key]
      // );

      // Sequential API call
      this.http.post(`${environment.profileURL}/api/v1/learner_maps/${col.learner_map_id}/learner_map_columns/${colId}/learner_map_cards`,cardPayload).subscribe(async (res:any)=> {
        console.log("res", res)
      })
    }
  } catch (error) {
    console.error("Error in cloneCards:", error);
  }
}

  	private async deleteCol(col) {
	    var that = this;
	    Swal.fire({
	        title: "Are you sure?",
	        text: "Are you sure, you want to delete this Card? This cannot be undone!",
	        icon: "warning",
	        showCancelButton: true,
	        focusCancel: true,
	        confirmButtonColor: "#dc3545",
	        cancelButtonColor: '#28a745',
	        confirmButtonText: "Yes, delete it!"
		}).then((result) => {
	        if (result['value'] == true) {
            this.isLoading = false;
	        	jQuery('.swal2-container').addClass('hide');
	    		  jQuery('body').removeClass('swal2-shown');
	    		jQuery('html').removeClass('swal2-shown');
          
            this.http.delete(`${environment.profileURL}/api/v1/learner_maps/${col.learner_map_id}/learner_map_columns/${col.id}`).subscribe(async (res:any)=> {
               setTimeout(function() {
                      this.toastr.options = {
                          closeButton: true,
                          progressBar: true,
                          timeOut: that.toaster_time
                      };
                      this.toastr.success('Your column has been deleted!', 'Nice!');
                  }, 1000);
                  await that.getLM();
                  this.isLoading = true;
            }, err => {
              console.log('oops', err);
              setTimeout(function() {
                      this.toastr.options = {
                          closeButton: true,
                          progressBar: true,
                          timeOut: that.toaster_time
                      };
                      this.toastr.error(err?.error?.errors, 'Oops!');
                  }, 1000);
                  this.isLoading = true;
            })
	        }else{
	            jQuery('.swal2-container').addClass('hide');
	            jQuery('body').removeClass('swal2-shown');
	            jQuery('html').removeClass('swal2-shown');
	        }
		},function(dismiss){
			jQuery('.swal2-container').addClass('hide');
			jQuery('body').removeClass('swal2-shown');
			jQuery('html').removeClass('swal2-shown');
		});
  	}

  private editCol(col) {
    this.editColId = col.id;
    this.editColName = col.title;
  }

  private async saveCol(col) {
    var that = this;
    let data = {
      title: this.editColName
    }
    console.log("abc", col)
    this.http.patch(`${environment.profileURL}/api/v1/learner_maps/${col.learner_map_id}/learner_map_columns/${col.id}`,data).subscribe(async (res:any)=> {
      console.log("res=>", res);
      that.allcolumns.forEach((col, index) => {
        if (col.id == that.editColId) {
            console.log("-------->",col)
            that.editColId = '';
            that.allcolumns[index] = res?.learner_map_column;
          }
        })
        setTimeout(function() {
          this.toastr.options = {
              closeButton: true,
              progressBar: true,
              timeOut: that.toaster_time
          };
          this.toastr.success('Your column has been updated!', 'Nice!');
      }, 1000);
    })
  }

  private cancelCol() {
    this.editColId = '';
  }

  private updateCardOrder(item, index) {
    if (item.position != index + 2 && item.id != this.CardId) {
      // this.api.UpdateCard({
      //   id: item.id,
      //   order: index + 2
      // })
    } else {
      return true;
    }
  }

  public open(){
    // $('.editlm-modal').css('display','block');
    this.editMap = true;
    // this.editMap = this.modalService.open(content, { size: 'lg', windowClass: 'in grey modalParent' });
    // this.edit_map = this.currentLM.title;
    let editLmTitle = '';
    this.hashTitleStaging = '';
    this.hashTitleProduction = '';
    let hash = 0;
    // feature between #
    console.log("edit learner map ", this.currentLM);
    for(let  i = 0; i < this.currentLM?.title?.length; i++) {
      if(this.currentLM.title[i] === '#') {
        hash += 1;
        continue;
      }
      if(hash > 0 && hash < 2) {
        this.hashTitleStaging += this.currentLM.title[i];
      }
      if(hash > 1) {
        this.hashTitleProduction += this.currentLM.title[i];
      }
      if(hash < 1){
        editLmTitle += this.currentLM.title[i]; 
        console.log(editLmTitle) 
      }
    }
    this.edit_map = editLmTitle;
    let owner_member = [];
    if(this.currentLM.owner_members.length > 0) {
      this.currentLM.owner_members.map((item)=> {
        owner_member.push(item.id)
      })
    }
    this.map_owner = owner_member;
    this.edit_maptype = String(this.currentLM.learner_map_type_id);
    this.edit_mapImage = this.currentLM.image;
    this.edit_mapLocation = this.currentLM.location;
    this.prework_days = this.currentLM.days_of_prework;
    this.assessment_deadline = this.currentLM.days_before_assessment_deadline;
    this.before_day_point = this.currentLM.days_before_point_due;
    this.days_test_opens = this.currentLM.days_after_training_before_test_opens;
    this.days_test_close = this.currentLM.days_after_training_before_test_closes;
    this.first_training = new Date(this.currentLM.training_first_date);
    this.last_training = new Date(this.currentLM.training_last_date);
  }

  private async UpdateLearnerMap(id?: any) {
    let that = this;
    that.editMap = false;
    let features_grp_staging = $('#feature-grp-staging').val();
    let features_grp_production = $('#feature-grp-production').val();
    this.edit_map += '#' +  features_grp_staging + '#' + features_grp_production + '#';
      let data = {
        title: this.edit_map, 
        owners: this.map_owner, 
        learnerMapMaptypeId: this.edit_maptype, 
        location: this.edit_mapLocation, 
        image: this.edit_mapImage, 
        days_of_prework: this.prework_days, 
        days_before_assessment_deadline: this.assessment_deadline, 
        daysBeforePointDue: this.before_day_point, 
        days_after_training_before_test_opens: this.days_test_opens, 
        days_after_training_before_test_closes: this.days_test_close, 
        training_first_date: this.first_training, 
        training_last_date: this.last_training
      }

      this.http.patch(`${environment.assessment_admin}api/v1/learner_maps/${this.currentLM_id}`, data).subscribe(data => {
        that.getLM();
        setTimeout(function() {
            this.toastr.options = {
                closeButton: true,
                progressBar: true,
                timeOut: that.toaster_time
            };
            this.toastr.success('Learner map has been updated!', 'Nice!');
        }, 1000);
      })

      // await this.api.UpdateLearnerMap({ id: this.currentLM_id, title: this.edit_map, owners: this.map_owner.toLowerCase(), learnerMapMaptypeId: this.edit_maptype, location: this.edit_mapLocation, image: this.edit_mapImage, daysOfPrework: this.prework_days, daysBeforeAssessmentDeadline: this.assessment_deadline, daysBeforePointDue: this.before_day_point, daysAfterTrainingBeforeTestOpens: this.days_test_opens, daysAfterTrainingBeforeTestCloses: this.days_test_close, trainingFirstDay: this.first_training, trainingLastDay: this.last_training }).then(async function (data) {
      //   // that.editMap.close();
        // that.close('editMap')
      // });
    // }
  }

  public increaseZindex() {
    setTimeout(() => {
      $('bs-datepicker-container').css('z-index','999999')
    }, 100);
  }

  // get column and cards using Lambda function 
  public async getLearnerMapColCard(lmId:string) {
    var that = this;
    let args = {
      lm_id: lmId,
      compName: "admin-single"
    }
    try {
      if (
        !this.router.url.includes("profile-slideshow") &&
        args.lm_id != "presentation"
      ) {
        await this.lmda_service.lambda_invoke(
          "read-dynamoDb-data",
          args
        );
      }
    } catch (err) {
      console.log(err);
    }
    await this.lmda_service?.lambda_res?.subscribe((res) => {
      console.log(res);
      let allcolumns = res["response"]?.body;
      // sorting columns
      allcolumns?.sort((a, b) => a?.position - b?.position);
      // sorting cards
      allcolumns?.forEach((col) => {
        col?.cards?.sort((a, b) => a?.position - b?.position);
      })
      console.log("allcolumns", allcolumns);
      that.allcolumns = allcolumns;
    })
  }


  makeMapOwner(member_id, e) {
    console.log('member_id', member_id, this.mapOwnersStaticObj)
    let isRemoved = false;
    this.mapOwnersStaticObj.forEach(owner => {
      console.log('owner', owner, owner.member_id === member_id)
      if (owner.member_id === member_id) {
        if(!owner.checked) {
          isRemoved = true;
        }
      }
    });

    if(!isRemoved) {
      let data = {
        owner_member_ids: [member_id]
      }
     this.http.post(`${environment.assessment_admin}api/v1/learner_maps/${this.currentLM_id}/remove_owner_members`, data).subscribe(async (res:any)=> {
       console.log('res', res)
       setTimeout(function() {
          this.toastr.options = {
              closeButton: true,
              progressBar: true,
              timeOut: 2000,
          };
          this.toastr.success(
              "Map Owners Removed Successfully!",
              "Nice!"
          );
      }, 1000);
     })
    } else {
      let data = {
        owner_member_ids: [member_id]
      }
     this.http.post(`${environment.assessment_admin}api/v1/learner_maps/${this.currentLM_id}/assign_owner_members`, data).subscribe(async (res:any)=> {
       console.log('res', res)
       setTimeout(function() {
          this.toastr.options = {
              closeButton: true,
              progressBar: true,
              timeOut: 2000,
          };
          this.toastr.success(
              "Map Owners Updated Successfully!",
              "Nice!"
          );
      }, 1000);
     })
    }
    
  }
}